let oAuthHelper = {
  semiLoggedInScope:
    "customer:profile:read:basic customer:card:read customer:orderHistory:read customer:loyalty:read customer:loyaltyHistory:read",
  loggedInScope:
    "customer:card:read customer:profile:read:extended customer:orderHistory:read customer:card:update customer:profile:read:basic customer:loyalty:read customer:orderHistory:update customer:card:create customer:loyaltyHistory:read order:place:cardOnFile customer:card:delete customer:orderHistory:create customer:profile:update easyOrder:optInOut easyOrder:read",
  getCurrentScope: function() {
    try {
      if (sessionStorage.accessTokens.length > 0) {
        return JSON.parse(
          atob(
            JSON.parse(sessionStorage.accessTokens)["customer-oauth"].split(
              "."
            )[1]
          )
        ).scope;
      }
      return [];
    } catch (ex) {
      return [];
    }
  },
  isSemiLoggedIn: function() {
    return this.getCurrentScope().join(" ") === this.semiLoggedInScope;
  },
  isLoggedIn: function() {
    return this.getCurrentScope().join(" ") === this.loggedInScope;
  }
};

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function serialize(obj) {
  return Object.keys(obj)
    .reduce((arr, key) => {
      arr.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
      return arr;
    }, [])
    .join("&");
}

function isHandheld() {
  const mediaQ = "screen and (max-width: 640px)";
  return (
    window.matchMedia &&
    window.matchMedia(mediaQ) &&
    window.matchMedia(mediaQ).matches
  );
}

export { validateEmail, serialize, isHandheld, oAuthHelper };
